<div class="snackbar">
  @if (dataObject?.type == 'warning') {
    <img alt="info" class="snackbar-info-image" [src]="'images/info.svg' | assetUrl" />
  }
  <div class="snackbar-message" matSnackBarAction>
    {{ dataObject.message }}
    @if (dataObject.actionButton) {
      <span class="snackbar-message-action-button" (click)="actionButtonClick()" (keypress)="actionButtonClick()">{{
      dataObject.actionButton.title }}</span>
    }
  </div>
  <img class="snackbar-close-image" (click)="closeSnackbar()" (keypress)="closeSnackbar()" [src]="'images/close_green.svg' | assetUrl"
    alt="user icon" />
  </div>